import { useState } from 'react'
import { Container } from 'ui/container'
import { AdventList, AdventStats } from 'features/admin/advent'
import { Link } from 'react-router-dom'
import { routes } from 'core/routes/paths'

import c from '../assets/sass/page.module.scss'
import t from './assets/sass/tabs.module.scss'

const AdminAdventPage = () => {
    const [view, setView] = useState('calendar')

    return (
        <div className={c.component}>
            <div className={c.header}>
                <Link to={routes.admin} className={c.back}>
                    ← Назад
                </Link>
                <span className={c.title}>Дейлик</span>
            </div>
            <Container>
                <div className={t.tabs}>
                    <button
                        className={view === 'calendar' ? t.tabActive : t.tab}
                        onClick={() => setView('calendar')}
                    >
                        📅 Календарь
                    </button>
                    <button
                        className={view === 'stats' ? t.tabActive : t.tab}
                        onClick={() => setView('stats')}
                    >
                        📊 Статистика
                    </button>
                </div>
                {view === 'calendar' && <AdventList />}
                {view === 'stats' && <AdventStats />}
            </Container>
        </div>
    )
}

export default AdminAdventPage
